<script>
    import PageComponentMixin from '../mixins/PageComponentMixin'

    export default {
        name: 'Html',
        mixins : [PageComponentMixin],
        data () {
            return {
                hide: false
            }
        },
        props: {
            originalTag: {
                type: String,
                default: ''
            }
        },
        created () {
            // Code for testing
            // if (this.originalTag == 'H1') {
            //     this.hide = true
            //     setTimeout(() => {
            //         this.hide = false
            //     }, 5000)
            // }
        },
        render(h, context) {
            const data = this
            const children = this.$slots.default? this.$slots.default : ''
            data.style = {...data.style, display: this.hide? 'none' : 'block'}
            return h(this.originalTag, data, children)
        },
    }
</script>